<template lang="pug">
#CamadasClientes
    el-card.mb-4.box-card(
        shadow='never',
        :body-style='{ padding: "10px" }',
        style='margin: 20px'
    )
        h3.mb-3
            i.mdi.mdi-filter-variant.mr-2
            | Filtros

        .filtros__input.mb-3
            el-select(
                v-model='camadasSelecionadas',
                style='width: 50%',
                placeholder='Selecione as camadas',
                multiple,
                filterable,
                value-key='idCamadas'
            )
                el-option(
                    v-for='camada in camadas',
                    :key='camada.codigo',
                    :label='camada.nome',
                    :value='camada.id'
                )

            el-select(
                v-model='empresasSelecionadas',
                style='width: 50%',
                placeholder='Selecione as empresas',
                multiple,
                filterable,
                value-key='idEmpresas'
            )
                el-option(
                    v-for='empresa in empresas',
                    :key='empresa.id',
                    :label='empresa.name',
                    :value='empresa.id'
                )

        .filtros__botao
            BaseButton(
                type='primary',
                size='mini',
                icon='el-icon-receiving',
                @click='buscarQtdCamadasPorEmpresa'
            ) Filtrar

    el-card.mb-4.box-card(
        shadow='never',
        :body-style='{ padding: "10px" }',
        style='margin: 20px'
    )
        .justify-content-end.d-flex
            el-button-group.mb-2
                BaseButton(
                    type='primary',
                    icon='el-icon-plus',
                    size='mini',
                    @click='mostrarModalVincular'
                ) Vincular camada em lote
                BaseButton(
                    type='primary',
                    icon='el-icon-delete',
                    size='mini',
                    @click='mostrarModalRemover'
                ) Remover camada em lote

        el-table.px-2(
            v-loading='carregandoTabela',
            :data='paginaQtdCamadasPorEmpresa.itens',
            size='mini'
        )
            el-table-column(
                label='Empresa (Grupo)',
                prop='nomeEmpresa',
                sortable,
                :min-width='25'
            )
            el-table-column(
                label='Número de camadas vinculadas',
                prop='qtdCamadas',
                sortable,
                :min-width='25',
                align='center'
            )
            el-table-column(label='Ação', :min-width='15', align='center')
                .template(slot-scope='scope')
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.el-icon-caret-bottom
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='visualizarCamadasEmpresa(scope.row)'
                            ) Visualizar camadas vinculadas

                            el-dropdown-item(
                                icon='el-icon-edit',
                                @click.native='editarCamadasEmpresa(scope.row)'
                            ) Editar camadas vinculadas

        .mt-4.px-2.justify-content-between.d-flex.align-items-center
            .totalizadores
                label.mr-3 Empresas: {{ empresas.length }}
                label Camadas vinculadas: {{ totalCamadasVinculadas }}

            el-pagination(
                small,
                background,
                layout='prev, pager, next',
                :page-size='paginacao.tamanho',
                :current-page.sync='paginacao.pagina',
                :total='paginaQtdCamadasPorEmpresa.totalItens',
                @current-change='atualizarPagina'
            )

    ModalVincularCamadas(
        :mostrar='mostrarModalVincularCamadas',
        :empresas='empresas',
        :camadas='camadas',
        :acao='acaoModal',
        @atualizar-tabela='buscarQtdCamadasPorEmpresa',
        @fechar='mostrarModalVincularCamadas = false'
    )

    ModalVisualizarCamadasVinculadas(
        :mostrar='mostrarModalVisualizarCamadas',
        :empresa='empresaModalVisualizarCamadas',
        @fechar='mostrarModalVisualizarCamadas = false'
    )

    ModalEditarCamadasVinculadas(
        :mostrar='mostrarModalEditarCamadas',
        :empresa='empresaModalEditarCamadas',
        :camadas='camadas',
        @atualizar-tabela='buscarQtdCamadasPorEmpresa',
        @fechar='mostrarModalEditarCamadas = false'
    )
</template>

<script>
import { CamadasService } from '@/services/CamadasService';
import ModalVincularCamadas from '@/components/adminRelatorios/ModalVincularCamadasEmLote';
import ModalVisualizarCamadasVinculadas from '@/components/adminRelatorios/ModalVisualizarCamadasVinculadas';
import ModalEditarCamadasVinculadas from '@/components/adminRelatorios/ModalEditarCamadasVinculadas';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'CamadasEmpresa',

    components: {
        ModalVincularCamadas,
        ModalVisualizarCamadasVinculadas,
        ModalEditarCamadasVinculadas,
        BaseButton
    },

    props: {
        empresas: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            camadas: [],
            camadasSelecionadas: [],
            empresasSelecionadas: [],
            totalCamadasVinculadas: 0,

            paginaQtdCamadasPorEmpresa: {},
            paginacao: {
                pagina: 0,
                tamanho: 50
            },

            mostrarModalVincularCamadas: false,
            acaoModal: '',

            mostrarModalVisualizarCamadas: false,
            empresaModalVisualizarCamadas: {},

            mostrarModalEditarCamadas: false,
            empresaModalEditarCamadas: {},

            carregandoTabela: false,
            carregandoTotalizadores: false
        };
    },

    mounted() {
        this.buscarCamadas();
        this.buscarEmpresas();
        this.buscarQtdCamadasPorEmpresa();
    },

    methods: {
        buscarEmpresas() {
            this.$emit('buscarEmpresas');
        },

        async buscarCamadas() {
            const { data } = await CamadasService.buscarCamadas();
            this.camadas = data.camadas;
        },

        async buscarQtdCamadasPorEmpresa() {
            this.carregandoTabela = true;

            this.buscarTotalCamadasVinculadas();

            const { data } = await CamadasService.buscarQtdCamadasPorEmpresa(
                {
                    idsCamadas: this.camadasSelecionadas,
                    idsEmpresas: this.empresasSelecionadas
                },
                this.paginacao
            );

            this.paginaQtdCamadasPorEmpresa = data;
            this.carregandoTabela = false;
        },

        async buscarTotalCamadasVinculadas() {
            const { data } =
                await CamadasService.buscarTotalCamadasVinculadas();
            this.totalCamadasVinculadas = data;
        },

        atualizarPagina(pagina) {
            this.paginacao.pagina = pagina;
            this.buscarQtdCamadasPorEmpresa();
        },

        mostrarModalVincular() {
            this.acaoModal = 'VINCULAR';
            this.mostrarModalVincularCamadas = true;
        },

        mostrarModalRemover() {
            this.acaoModal = 'REMOVER';
            this.mostrarModalVincularCamadas = true;
        },

        visualizarCamadasEmpresa(empresa) {
            this.empresaModalVisualizarCamadas = empresa;
            this.mostrarModalVisualizarCamadas = true;
        },

        editarCamadasEmpresa(empresa) {
            this.empresaModalEditarCamadas = empresa;
            this.mostrarModalEditarCamadas = true;
        }
    }
};
</script>

<style lang="scss" scoped>
.filtros__input {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.filtros__botao {
    display: flex;
    justify-content: flex-end;
}

.el-table.px-2.el-table--fit.el-table--enable-row-hover.el-table--enable-row-transition {
    height: 350px;
    overflow: scroll;
}
</style>
